som-collapse {
    @mixin transition($name, $duration) {
      -webkit-transition: $name $duration;
      -moz-transition: $name $duration;
      -o-transition: $name $duration;
      transition: $name $duration;
    }
  
    .collapse-content-container {
      @include transition(height, 0.3s);
  
      position: relative;  /* Prevents background content from messing with height */
  
      &.overflow-hidden {
        overflow: hidden;
      }
    }
  
    .collapse-content {
      &.display-none {
        display: none;
      }
    }
  
    /*
      User can set the class `d-none` on the child content for the space not to be taken on screen before `som-collapse` resolves.
      This is useful when the Collapse component should be collapsed by default.
  
      Example:
      <som-collapse collapsed="true">    // <---- Collapsed by default
        <div class="d-none">      // <---- Makes child content `display: none`
          Hello world!
        </div>
      </som-collapse>
  
      The following style will change it to `display: block` when component is hydrated.
    */
    &.hydrated {
      .collapse-content > * {
        display: block !important;
      }
    }
  }
  